import MapAreaInput from './MapArea';

export {MapAreaInput as MapArea};
